import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { HelmetProvider } from 'react-helmet-async';
import { CustomizationProvider } from './contexts/CustomizationContext';
import App from './App';
import './index.css';
// import './lib/i18n';

// Importa handlers de erro globais
import { installGlobalErrorHandlers } from './components/GlobalErrorHandler';
import { installNetworkInterceptor } from './components/NetworkInterceptor';
import ErrorBoundary from './components/ErrorBoundary';
import { PageSkeleton } from './components/PageSkeleton';

// Importa e inicializa o tema
import { useThemeStore } from './stores/themeStore';

// Instala handlers globais
installGlobalErrorHandlers();
installNetworkInterceptor();

// Inicializa o tema
useThemeStore.getState().initializeTheme();

// Create a client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000, // 5 minutes
      refetchOnMount: true,
      refetchOnReconnect: true,
      gcTime: 10 * 60 * 1000, // 10 minutes (anteriormente cacheTime)
    },
    mutations: {
      retry: 1,
      retryDelay: 1000,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <HelmetProvider>
          <BrowserRouter>
            <CustomizationProvider>
              <React.Suspense fallback={<PageSkeleton />}>
                <App />
              </React.Suspense>
            </CustomizationProvider>
            <Toaster
              position="top-right"
              toastOptions={{
                duration: 4000,
                style: {
                  background: 'hsl(var(--card))',
                  color: 'hsl(var(--card-foreground))',
                  border: '1px solid hsl(var(--border))',
                },
                success: {
                  iconTheme: {
                    primary: 'hsl(var(--primary))',
                    secondary: 'white',
                  },
                },
                error: {
                  iconTheme: {
                    primary: 'hsl(var(--destructive))',
                    secondary: 'white',
                  },
                },
              }}
            />
          </BrowserRouter>
        </HelmetProvider>
        {/* Temporariamente desabilitado para debug */}
        {/* {process.env.NODE_ENV === 'development' && <ReactQueryDevtools initialIsOpen={false} />} */}
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
